import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IonicPageModule } from 'ionic-angular';
import { ShopperHomePage } from './shopper-home';

@NgModule({
  declarations: [
    ShopperHomePage,
  ],
  imports: [
    IonicPageModule.forChild(ShopperHomePage),
    TranslateModule.forChild()
  ],
})
export class ShopperHomePageModule {}



// WEBPACK FOOTER //
// ./src/pages/shopper-home/shopper-home.module.ts